import { defineComponent as _defineComponent } from 'vue'
import DetailAccordion from '@/components/DetailAccordion.vue';
import AlertWorkflowStatusSelect from '@/components/inputs/AlertWorkflowStatusSelect.vue';
import DisplayInput from '@/components/inputs/DisplayInput.vue';
import DisplayDatepicker from '@/components/inputs/DisplayDatepicker.vue';
import DisplayTaginput from '@/components/inputs/DisplayTaginput.vue';
import {
  AlertWorkflowDetail,
  AlertWorkflowStatus,
} from '@/models/alertWorkflow';
import { alertWorkflowsService } from '@/services/alertWorkflows.service';
import { isEmpty, isNil, valueOrDefault } from '@/utils/misc';
import {
  formatWithUnit,
  translateKpi,
  translateOperator,
  translateVariable,
} from '@/utils/alerts';
import { translateDateGrouping } from '@/utils/dates';
import { router } from '@/library-services/e-service-center-router';
import { computed, onMounted, ref, shallowRef } from 'vue';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertWorkflowDetailsModal',
  props: {
    alertWorkflowId: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  alertWorkflowId: number;
};





const alertWorkflow = shallowRef<AlertWorkflowDetail | null>(null);

const isLoading = ref(false);

const { t } = useI18n();

onMounted(async () => {
  await loadData();
});

async function loadData() {
  isLoading.value = true;
  try {
    alertWorkflow.value = await alertWorkflowsService.getDetail(
      props.alertWorkflowId,
    );
  } finally {
    isLoading.value = false;
  }
}

async function goToEquipmentCareConsole() {
  emit('close');
  await router.goToEquipmentAlertTabOnCareConsole(
    alertWorkflow.value!.customer.tenantIdDh,
    alertWorkflow.value!.equipment.deviceId,
  );
}

async function goToWorkCenterConsole() {
  emit('close');
  await router.goToEquipmentWorkCenterConsole(
    alertWorkflow.value!.customer.tenantIdDh,
    alertWorkflow.value!.equipment.deviceId,
  );
}

const workflowHasEventCodes = computed<boolean>(
  () => !isEmpty(alertWorkflow.value?.alertOccurrence.eventCodes),
);

const workflowHasEventSources = computed<boolean>(
  () => !isEmpty(alertWorkflow.value?.alertOccurrence.eventSources),
);

return { __sfc: true,props, emit, alertWorkflow, isLoading, t, loadData, goToEquipmentCareConsole, goToWorkCenterConsole, workflowHasEventCodes, workflowHasEventSources, DetailAccordion, AlertWorkflowStatusSelect, DisplayInput, DisplayDatepicker, DisplayTaginput, AlertWorkflowStatus, isNil, valueOrDefault, formatWithUnit, translateKpi, translateOperator, translateVariable, translateDateGrouping }
}

})